import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Typography,
  FormControl,
} from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import {
  ButtonCreate,
  SearchTextField,
  PageHeaderTitle,
} from "../../Utils/Component";

import { AuthContext } from "../../Context/AuthContext";
import { SelectParty } from "../../Components/Include/DynamicSelect";
import { useGetMemberInMandatePagination } from "../../Hooks/useGetMemberInMandatePagination";

import MemberInMandateForm from "../../Components/MemberInMandate/MemberInMandateForm";
import MemberInMandateActive from "./MemberInMandateActive";
import MemberInMandateLossOfMembership from "./MemberInMandateLossOfMembership";

export default function Secretarait() {
  const { t } = useContext(AuthContext);

  const [selectParty, setSelectParty] = useState({ id: "", title: "" });
  const [isActive, setIsActive] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetMemberInMandatePagination({
    partyId: selectParty?.id,
    isActive: isActive,
  });


  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/member-in-mandate"}
        pageTitle={t("page_provincial_council_member")}
      />

      <Box>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_from_party")}
            </Typography>
            <SelectParty
              buttonAdd={false}
              className={"text-field"}
              value={selectParty}
              onChange={(val) => {
                setSelectParty(val);
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_status")}
            </Typography>
            <FormControl className={"text-field"} fullWidth size="small">
              <Select
                value={isActive.toString()}
                onChange={(e) => setIsActive(e.target.value === "true")}
              >
                <MenuItem value="false">{t("thead_is_active")}</MenuItem>
                <MenuItem value="true"> {t("thead_loss_of_membership")} </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={12} lg={3} xl={4.8}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            <MemberInMandateForm
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
              dialogTitle="Create"
            />
          </Grid>
        </Grid>
      </Box>

      {
        isActive ?
          <MemberInMandateLossOfMembership
            page={page}
            limit={limit}
            loading={loading}
            refetch={refetch}
            setPage={setPage}
            tableData={tableData}
            setLoading={setLoading}
            handleLimit={handleLimit}
            paginationData={paginationData}
          /> :
          <MemberInMandateActive
            page={page}
            limit={limit}
            loading={loading}
            refetch={refetch}
            setPage={setPage}
            tableData={tableData}
            setLoading={setLoading}
            handleLimit={handleLimit}
            paginationData={paginationData}
          />
      }
    </div>
  );
}
